import { Checkbox } from '@components/_ui/Checkbox'
import { Radio } from '@components/_ui/Radio'
import { clsx } from 'clsx'

import s from './Grid.module.scss'
import type { GridProps } from './Grid.props'

export function Grid({ options, rootClassName, itemClassName, type = 'radio', ...props }: GridProps) {
  if (!options?.length) return null

  const Component = type === 'radio' ? Radio : Checkbox

  return (
    <div className={clsx(s.grid, rootClassName)}>
      {options.map((option, index) => (
        <div
          key={`${option.db_item_name}-${index}`}
          className={s.item}
        >
          <Component
            {...props}
            value={option.db_item_name}
            label={option.item}
            icon={option?.image || ''}
            className={clsx(s.input, itemClassName)}
          />
        </div>
      ))}
    </div>
  )
}
